const BASE_API = '/api';

const AUTH = {
  LOGIN: `${BASE_API}/login`,
  LOGOUT: `${BASE_API}/logout`,
  SIGNUP: `${BASE_API}/user/register`,
  VERIFY_ACCOUNT: `${BASE_API}/user/validate`,
  FORGOT_PASSWORD: `${BASE_API}/user/recover_password`,
  CHANGE_PASSWORD: `${BASE_API}/user/change_password`,
  UPDATE_PASSWORD: `${BASE_API}/user/update_password`, // user settings
};

const PING = `${BASE_API}/health/ping`;

// USERS
const USER = `${BASE_API}/user`;

// REPORTS
const REPORTS = `${BASE_API}/reports/:report_id`;

const REPORT = {
  CALCULATE: `${BASE_API}/reports/calculate`,
  DOWNLOAD_CSV: `${BASE_API}/reports/csv/:csv`,
  VERIFY_CSV: `${BASE_API}/reports/csv/:csv/verify`,
  GENERATE: `${BASE_API}/reports/:report_id/pdf`,
  DUPLICATE: `${BASE_API}/reports/:report_id/duplicate`,
  PRICE: `${BASE_API}/reports/price`,
};

const CONFIG = `${BASE_API}/config/:id`;

const BASE_ADMIN = `${BASE_API}/admin`;

const ADMIN = {
  SUBSCRIPTIONS: `${BASE_ADMIN}/companies/:companyId/subscriptions/:subscriptionId`,
};

const PLAN = `${BASE_API}/plans/:id`;

const COMPANIES = `${BASE_API}/companies/:id`;

const COMPANY = {
  USERS: `${BASE_API}/companies/:id/users`,
  REPORT: `${BASE_API}/companies/:companyId/reports/:reportId`,
  REPORTS: `${BASE_API}/companies/:id/reports`,
  CALCULATED_REPORTS: `${BASE_API}/companies/:id/reports/calculated`,
  SUBSCRIPTIONS: `${BASE_API}/companies/:companyId/subscriptions`,
};

const BASE_CATALOG = `${BASE_API}/catalog`;

const CATALOG = {
  REPORT_SCHEMA: `${BASE_CATALOG}/report_schema_{version}.json`,
};

const CONTACT = `${BASE_API}/contact`;

const API = {
  ADMIN,
  AUTH,
  BASE_CATALOG,
  CATALOG,
  COMPANIES,
  COMPANY,
  CONFIG,
  CONTACT,
  PING,
  PLAN,
  REPORT,
  REPORTS,
  USER,
};

export { API }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/config/api.config.js